import { Button, InlineError, Spinner, Switch } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import UploadImage from 'components/commons/upload-image'

export const BannerSection = ({ data, onChangeForm, errorForm, isLoadingUpload, isLoading, isUpdating, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-6 pb-[280px] overflow-auto'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center justify-between border border-neutral-20 px-6 py-4 rounded-lg'}>
                        <p className={'font-semibold text-lg text-black-95'}>{'Banner'}</p>
                        <div className={'flex items-center space-x-6'}>
                            <p className={'font-semibold'}>{data?.is_show ? 'Show' : 'Hide'}</p>
                            <Switch
                                name={'is_show'}
                                checked={data?.is_show}
                                onChange={(e) => onChangeForm({ ...e, value: e.checked })}
                            />
                        </div>
                    </div>
                    <TabToggle
                        title={'Banner'}
                        content={
                            <div className={'flex space-x-16'}>
                                <div className={`flex-1 flex-col space-y-3`}>
                                    <div className={'font-semibold text-blue-90 required'}>
                                        Banner Desktop (1366px x 563px)
                                    </div>
                                    <UploadImage
                                        className={'w-fit'}
                                        classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                        id={`banner-desktop`}
                                        value={data?.desktop_banner?.base64 || data?.desktop_banner}
                                        onChange={(value) => onChangeForm({ name: 'desktop_banner', value })}
                                    />
                                    <InlineError className={'mt-2'} message={errorForm?.desktop_banner} />
                                </div>

                                <div className={`flex-1 flex-col space-y-3`}>
                                    <div className={'font-semibold text-blue-90 required'}>
                                        Banner Mobile (414px x 693px)
                                    </div>
                                    <UploadImage
                                        className={'w-fit'}
                                        classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                        id={`banner-mobile`}
                                        value={data?.mobile_banner?.base64 || data?.mobile_banner}
                                        onChange={(value) => onChangeForm({ name: 'mobile_banner', value })}
                                    />
                                    <InlineError className={'mt-2'} message={errorForm?.mobile_banner} />
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex justify-end w-[calc(100%-544px)] py-3 bg-white fixed bottom-0 right-9 z-20'}>
                        <Button
                            className={'w-[200px] !bg-gradient-to-r !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                            loading={isLoadingUpload || isUpdating}
                            title={'SAVE ALL CHANGES'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
